module.exports = __webpack_public_path__ + "2e6c7afba5f1c4ffd677f1a4230d4cce.png";